import React from 'react';
import cn from 'classnames';

import CurrencyFormat from 'src/components/CurrencyFormat';
import type { OrderPriceInfo } from 'checkout/store/order/types';
import { PriceDetails, PriceDetailsItem } from '../PriceDetails';

const baseCls = 'checkout-summary-prices';

export interface PriceInfoProps {
  data?: OrderPriceInfo[];
}

const PriceInfo = ({ data }: PriceInfoProps) => (
  <div>
    <PriceDetails className={baseCls}>
      {data &&
        data.map(({ title, amount, price_id }) => {
          const isDiscount = amount < 0;
          const prefix =
            price_id === 'package_net_price'
              ? null
              : (isDiscount && '- ') || '+ ';
          return (
            <PriceDetailsItem
              key={price_id}
              className={cn({ [`${baseCls}__item--discount`]: isDiscount })}
              label={title}
            >
              <div>
                <CurrencyFormat
                  className={`${baseCls}__value`}
                  value={Math.abs(amount)}
                  prefix={prefix}
                />
              </div>
            </PriceDetailsItem>
          );
        })}
    </PriceDetails>
  </div>
);

export default PriceInfo;
